import React, { useState, useEffect } from 'react'; // Import useEffect here
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

// Removed duplicate MUI imports below

const SaveChatDialog = ({ open, onClose, onSave, defaultTitle = '', saving = false }) => {
  const [title, setTitle] = useState('');

  // Reset title when dialog opens or defaultTitle changes
  useEffect(() => {
    if (open) {
      setTitle(defaultTitle || ''); // Use defaultTitle if provided, otherwise empty
    }
  }, [open, defaultTitle]);

  const handleSave = () => {
    // Use the current title state, or generate a default if empty
    onSave(title.trim() || `Sohbet ${new Date().toLocaleString()}`);
  };
  
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Sohbeti Kaydet</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2, mt: 1 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Bu sohbeti kaydederek daha sonra devam edebilir veya başkalarıyla paylaşabilirsiniz.
          </Typography>
        </Box>
        <TextField
          autoFocus
          margin="dense"
          label="Sohbet Başlığı"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder={`Sohbet ${new Date().toLocaleString()}`}
          disabled={saving}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>İptal</Button>
        <Button 
          onClick={handleSave} 
          variant="contained"
          startIcon={saving ? <CircularProgress size={20} /> : <SaveIcon />}
          disabled={saving}
        >
          {saving ? 'Kaydediliyor...' : 'Kaydet'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveChatDialog;
